import { useStoreSystem } from "../store";
import shallow from "zustand/shallow";
import { useAlerts } from "./useAlerts";
import { useCallback } from "react";
import { useCurrentSearchParam } from "../utils/hooks/useCurrentSearchParam";
import { useNavigate } from "react-router-dom";

type SaveProjectParams = {
    isNewProject?: boolean;
    isShowModal?: boolean;
}

export const useSaveProject = (): (({ isNewProject, isShowModal }: SaveProjectParams) => Promise<string | undefined>) => {
    const saveProject = useStoreSystem((state) => state.saveProject, shallow);
    const navigate = useNavigate();
    const currentProjectUserId = useStoreSystem((state) => state.currentProjectUserId);
    const setSavedProjectModal = useStoreSystem((state) => state.setSavedProjectModal);
    const [hash] = useCurrentSearchParam("hash");
    const { addReadyAlert } = useAlerts();

    //Сохранение проекта с обработкой ошибок и алертами
    return useCallback(
        async ({ isNewProject, isShowModal = true }) => {
            try {
                const newHash = await saveProject(hash, isNewProject);
                if (!newHash) {
                    addReadyAlert("Не удалось сохранить проект", "error");
                    return;
                }
                if (hash !== newHash) {
                    navigate(`?hash=${newHash}`);
                }
                if (isShowModal) {
                    if (isNewProject || !hash || newHash !== hash) {
                        setSavedProjectModal(true, newHash, false);
                        // addReadyAlert(`Сохранен новый проект с хэшем ${newHash}`, "success");
                    } else {
                        setSavedProjectModal(true, newHash, true);
                        // addReadyAlert(`Проект с хэшем ${newHash} обновлен`, "success");
                    }
                }
                return newHash;
            } catch (e: unknown) {
                if (typeof e === "string") {
                    addReadyAlert(e, "error");
                } else if (e instanceof Error) {
                    addReadyAlert(e.message, "error");
                }
            }
        },
        [saveProject, hash, addReadyAlert, navigate]
    );
};
